<script>
  import { useQuery } from "@sveltestack/svelte-query";
  import superagent from "superagent";

  import UserInformation from "./UserInformation.svelte";
  import EditProfile from "./EditProfile.svelte";
  import ConnectDevices from "./ConnectDevices.svelte";
  import ShowDocument from "./ShowDocument.svelte";
  import GiveAccess from "../sharing/GiveAccess.svelte";
  import { locale, locales, _ } from "svelte-i18n";
  import TrainerAccessDetails from "./TrainerAccessDetails.svelte";

  let editUserInformationActive = false;
  let showErrorMessage = false;
  let coachDetails = false;

  let showReportWithType = false;
  let showGiveAccess = false;
  let alreadyAddedTrainers = [];

  function editProfile() {
    editUserInformationActive = true;
    window.document.body.classList.toggle("modal-is-active");
    coachDetails = true;
  }

  function giveAccess() {
    if (!$trainers.isLoading && $trainers.data) {
      alreadyAddedTrainers = myTrainers.map((trainer) => trainer.id);
      showGiveAccess = true;
      window.document.body.classList.add("modal-is-active");
    }
  }

  function createCoachUser() {
    editProfile();
    coachDetails = true;
  }

  function createUser() {
    editProfile();
    coachDetails = false;
  }

  const storedUser = localStorage.getItem("user");
  var myTrainers = [];
  var myAthletes = [];
  let env;
  let user =
    storedUser !== null
      ? JSON.parse(storedUser)
      : {
          name: "",
          surname: "",
          email: "",
          countryCode: "47",
          phone: "",
          club: "",
          school: "",
          gender: "",
          birthDate: "",
        };
  const currentUser = useQuery("me-profile", () =>
    user.id !== undefined
      ? superagent
          .get("/api/me")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => {
            env = response.headers.environment;
            return response.body;
          })
      : superagent.get("/api/me").end((err, response) => {
          env = response.headers.environment;
        })
  );

  $: if (
    !$currentUser.isLoading &&
    $currentUser.data &&
    user !== undefined &&
    user.version !== $currentUser.data.version
  ) {
    user = $currentUser.data;
    localStorage.setItem("user", JSON.stringify(user));
  }

  function saveToServer(updatedUser) {
    return new Promise((resolve, reject) => {
      if (user !== undefined) {
        console.log("[INFO] Save user information", updatedUser);
        (user?.id === undefined
          ? superagent.post("/api/users")
          : superagent.put("/api/users/" + user.id)
        )
          .set({
            "Content-Type": "application/json",
            Authorization:
              updatedUser.id !== undefined
                ? "Bearer " + updatedUser.id
                : undefined,
          })
          .send(updatedUser)
          .then((response) => {
            user = {
              ...updatedUser,
              id: updatedUser.id === undefined ? response.body.id : user.id,
              rinkResults: response.body.rinkResults,
              consent: response.body.consent,
              version: response.body.version,
            };
            localStorage.setItem("user", JSON.stringify(user));
            console.log("[INFO] Saved to server");
            window.location.href = "/profil";
            resolve(user);
          })
          .catch((error) => {
            console.log("[ERROR] Not able to save to server, got", error);
            reject(error);
          });
      } else {
        reject({ noUser: true });
      }
    });
  }

  function updateUser(updatedUser) {
    return new Promise((resolve, reject) => {
      user = updatedUser;
      saveToServer(user)
        .then((user) => {
          localStorage.setItem("user", JSON.stringify(user));
          editUserInformationActive = false;
          resolve(user);
        })
        .catch((error) => {
          showErrorMessage = true;
          reject(error);
        });
    });
  }

  const trainers = useQuery("my-trainers", () =>
    user.id !== undefined
      ? superagent
          .get("/api/my-trainers")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => {
            return response.body;
          })
      : superagent.get("/api/me").end((err, response) => {})
  );

  const athletes = useQuery("my-athletes", () =>
    user.id !== undefined
      ? superagent
          .get("/api/my-athletes")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => response.body)
      : []
  );

  $: if (!$trainers.isLoading && $trainers.data) {
    myTrainers = $trainers.data.filter((trainer) => trainer.id !== user.id);
  }

  $: if (!$athletes.isLoading && $athletes.data) {
    myAthletes = $athletes.data;
  }

  function deleteTrainer(trainerId) {
    console.log("[INFO] Delete trainer", trainerId);
    superagent
      .delete("/api/trainers/" + trainerId)
      .set("Authorization", "Bearer " + user.id)
      .then((response) => {
        console.log("[INFO] Trainer deleted", response);
        $trainers.refetch();
      })
      .catch((error) => {
        console.log("[ERROR] Not able to delete trainer", error);
      });
  }
</script>

<div class="page-body">
  <div class="content">
    <div class="layout layout--masonry">
      <UserInformation
        edit={editProfile}
        newUser={{
          athlete: createUser,
          coach: createCoachUser,
          professional: createUser,
        }}
        bind:user
      />
      {#if user.id}
        {#if false}
          <ConnectDevices />
        {/if}
        <div class="layout__item">
          <h2 class="layout__title">{$_("profile.access.title")}</h2>
          <div class="card">
            <ul class="list-simple">
              {#each myTrainers as trainer}
                <TrainerAccessDetails {trainer} refetch={$trainers.refetch} />
              {/each}
            </ul>
            <a
              on:click|preventDefault={giveAccess}
              class="button"
              href="/minside/gi-tilgang">{$_("profile.access.grantAccess")}</a
            >
          </div>
        </div>
        {#if user.coachClub || user.coachFederation}
          <div class="layout__item layout__item--break">
            <h2 class="layout__title">{$_("profile.myAthletes")}</h2>
            <div class="card">
              {#if true}
                <section class="card__section">
                  <ul class="list-simple">
                    {#each myAthletes as athlete}
                      <a href={"/planer?" + athlete.id}
                        ><li>{athlete.name} {athlete.surname}</li></a
                      >
                    {/each}
                  </ul>
                </section>
              {/if}
              {#if false}
                <section class="card__section">
                  {#if false}
                    <a
                      on:click|preventDefault
                      class="button button--icon button--no-space button--icon-add"
                      href="/minside/legg-til-utover">Legg til utøver</a
                    >
                  {/if}
                  {#if false}
                    <a
                      on:click|preventDefault
                      class="button-text button-text--top-right button-text--no-space button-text--trashcan"
                      href="/minside/fjern-utover">Fjern utøver(e)</a
                    >
                  {/if}
                </section>
              {/if}
            </div>
          </div>
        {/if}
        {#if false}
          <div class="layout__item">
            <h2 class="layout__title">Grupper</h2>
            <div class="card">
              <section class="card__section">
                <a
                  on:click|preventDefault
                  class="button button--icon button--icon-add"
                  href="/minside/ny-gruppe">Ny gruppe</a
                >
              </section>
            </div>
          </div>
        {/if}
      {/if}
    </div>
    {#if user?.id !== undefined}
      <footer class="content__footer">
        <div class="layout">
          <h2 class="h3">{$_("profile.account.title")}</h2>
          <nav class="nav-list-links">
            <a
              style="text-decoration:underline; cursor:pointer;"
              on:click={() => {
                showReportWithType = "termsOfService";
              }}>{$_("profile.account.termsOfService")}</a
            >
            <a
              style="text-decoration:underline; cursor:pointer;"
              on:click={() => {
                showReportWithType = "healthAgreement";
              }}>{$_("profile.account.healthData")}</a
            >
            <a
              style="text-decoration:underline; cursor:pointer;"
              on:click={() => {
                showReportWithType = "privacy";
              }}>{$_("profile.account.privacyPolicy")}</a
            >
            {#if false}<a href="/minside/endre-passord">Endre passord</a>
            {/if}
            <a>
              <select
                on:change={(e) =>
                  localStorage.setItem("language", e.target.value)}
                bind:value={$locale}
              >
                {#each $locales as locale}
                  <option value={locale}>{locale}</option>
                {/each}
              </select></a
            >
            <button
              on:click={() => {
                localStorage.removeItem("user");
                window.location.href = "/profil";
              }}
              type="button"
              class="button-text button-text--logout"
              >{$_("profile.account.logOut")}</button
            >
          </nav>
        </div>
      </footer>{/if}
  </div>
  <EditProfile
    bind:active={editUserInformationActive}
    {user}
    {env}
    {updateUser}
    coach={coachDetails}
    bind:showErrorMessage
  />
  {#if showReportWithType}
    <ShowDocument
      active={showReportWithType}
      onClose={() => (showReportWithType = false)}
      documentType={showReportWithType}
    />
  {/if}
</div>
{#if showGiveAccess}
  <GiveAccess
    active={showGiveAccess}
    {alreadyAddedTrainers}
    onClose={() => {
      showGiveAccess = false;
      window.document.body.classList.remove("modal-is-active");
    }}
  />
{/if}
